export const LOCALE_PREFIX = 'components.Tabs.components.TabsWrap.components.Tab'

export const LEVELS_WITH_HISTORY = ['20', '40', '10,20', '20,40', '30,40', '10,30,40', '10,20,30,40', '10,20,30,40,50']
